import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Dialer from "@/services/dialer/dialer";
import type { DialerWrapupResult, SubmitDialerWrapup } from "@/dtos/Dialer.dto";

export function useDialerWrapup() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: SubmitDialerWrapup): Promise<DialerWrapupResult> => {
      const result = await Dialer.submitWrapup(data);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to submit call wrap-up");
      }
      return result.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["dialerSession", "active"] });
      queryClient.invalidateQueries({ queryKey: ["dialerPresence"] });
    },
  });
}
